"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      ruleForm: {},
      loading: false,
      details: {},
      addresData: [],
      brandOption: []
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getCityList();
    this.searchBrand('');
    this.ruleForm = {};
    this.details = {};
    if (id && id != 0) {
      this.getSpecDetail(id);
    }
    ;
  },
  methods: {
    throttle: _throttle.default,
    handerSubmit: function handerSubmit(form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        var _datas, _datas2;
        if (!valid) return;
        _this.loading = true;
        var datas = _objectSpread({}, _this.ruleForm || {});
        var _ref = ((_datas = datas) === null || _datas === void 0 ? void 0 : _datas.areaList) || [],
          _ref2 = _slicedToArray(_ref, 2),
          provinceCode = _ref2[0],
          cityCode = _ref2[1];
        datas = _objectSpread(_objectSpread({}, datas), {}, {
          provinceCode: provinceCode,
          cityCode: cityCode
        });
        (_datas2 = datas) === null || _datas2 === void 0 ? true : delete _datas2.areaList;
        dangaoActApi.updateShop(_objectSpread(_objectSpread({}, datas), {}, {
          source: 1
        })).then(function (data) {
          _this.$closeCompletedView();
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.goReturn();
        }).catch(function () {
          _this.loading = false;
        });
      });
    },
    getSpecDetail: function getSpecDetail(id) {
      var _this2 = this;
      this.details = {};
      dangaoActApi.getDetialShop(id).then(function (res) {
        _this2.details = res;
        var _ref3 = res || {},
          provinceCode = _ref3.provinceCode,
          cityCode = _ref3.cityCode;
        _this2.ruleForm = _objectSpread(_objectSpread({}, res), {}, {
          areaList: provinceCode && cityCode ? [Number(provinceCode), Number(cityCode)] : []
        });
      });
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/store/dangao/shoplist');
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        _this3.$set(_this3.ruleForm, 'storePic', img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg() {
      this.$set(this.ruleForm, 'storePic', '');
    },
    getCityList: function getCityList() {
      var _this4 = this;
      this.addresData = [];
      logistics.cityListTree2().then(function (res) {
        _this4.addresData = res || [];
      });
    },
    searchBrand: function searchBrand() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword, 1).then(function (res) {
        _this5.brandOption = res && res.length && res.map(function (item) {
          var _ref4 = item || {},
            brandId = _ref4.brandId,
            brandName = _ref4.brandName,
            source = _ref4.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this6 = this;
      this.throttle(function () {
        _this6.searchBrand(data);
      }, 300)();
    }
  }
};